module.exports = __webpack_public_path__ + "static/media/replate-white.9199dddf.svg";